import React from 'react';
import { Input } from 'antd-mobile-v5';
import { useDebounceFn } from 'ahooks';
import styles from '../index.less';

const TicketSearchBar = ({ onSearchValueChange, placeholder = '可搜索设备名称/分组/类型' }) => {
  //  防抖处理，防止频繁触发请求接口
  const { run: handleSerachTicket } = useDebounceFn(
    val => {
      onSearchValueChange(val);
    },
    {
      wait: 200,
    }
  );

  return (
    <div className={styles.searchBarWrapper}>
      <div className={styles.searchBar}>
        <Input clear placeholder={placeholder} onChange={handleSerachTicket} />
      </div>
    </div>
  );
};
export default TicketSearchBar;
